import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Link from '@material-ui/icons/Link';

import { dialogStyles } from '../styles';
import { withStyles } from '@material-ui/core/styles';

function LinksDialog (props) {

    const { classes, handleSubmit, open, handleClose } = props;

    const defaultValues = {text: '', url: ''};

    const [values, setValues] = useState(defaultValues);
    
    const [validated, setValidated] = useState(false);

    useEffect(() => {
        setValidated(values.text !== '' && values.url !== '');
    }, [values]);

    const handleClick = e => {
        e.preventDefault();
        handleSubmit(values)
        close();
    };

    const handleCancel = e => {
        e.preventDefault();
        close();
    };

    const close = () => {
        setValues(defaultValues);
        setValidated(false)
        handleClose();
    }

    const handleChange = ({ target }) => setValues(values => ({ ...values, [target.name]: target.value }))

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <div className={classes.header}>
                <IconButton size="medium" color="inherit" disableRipple disableTouchRipple><Link /></IconButton>
                <Typography variant="h6" color="inherit">Link</Typography>
            </div>
            <DialogContent className={classes.content}>
                <form className={classes.formContainer}>
                    <Typography variant="body1">
                        Enter text to display for the link and the full (absolute) URL of the webpage to direct users to when clicked.
                    </Typography>
                    <TextField
                        id="linkText"
                        name="text"
                        label="Link Text"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        fullWidth
                        required
                        value={values.text}
                        onChange={handleChange}
                        placeholder="ex. Visit Example website"
                    />
                    <TextField
                        id="linkUrl"
                        name="url"
                        label="Link URL"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">http://</InputAdornment>,
                        }}
                        fullWidth
                        required
                        value={values.url}
                        onChange={handleChange}
                        placeholder="ex. www.example.org"
                    />
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button color="primary" onClick={handleClick} disabled={!validated}>Submit</Button>
            </DialogActions>

        </Dialog>
    )
}

export default withStyles(dialogStyles)(LinksDialog);
